import { tokens } from '@sail/ui';
import { chromaFlavorColor } from '../tokens/customColor';
export const chromaTokens = {
    tokens: {
        ...chromaFlavorColor
    },
    themeTokens: {
        dark: {
            blendForeground: '#7a73ff',
            blendIntersection: '#ccffff',
            blendBackground: '#00d4ff'
        }
    },
    accents: {
        cyan: {
            tokens: {
                accentColor: '#02bcf5'
            },
            themeTokens: {
                dark: {
                    accentColor: '#00d4ff'
                }
            }
        },
        blurple: {
            themeTokens: {
                dark: {
                    accentColor: '#7a73ff'
                }
            }
        },
        blue: {
            tokens: {
                accentColor: '#00ff00'
            }
        },
        orange: {
            tokens: {
                accentColor: '#ff7600'
            }
        },
        slate: {
            tokens: {
                accentColor: '#0a2540'
            },
            themeTokens: {
                dark: {
                    accentColor: '#ffffff'
                }
            }
        }
    }
};
export const chromaSailTokens = {
    accents: {
        slate: {
            tokens: {
                text: {
                    onAction: {
                        secondary: {
                            hovered: tokens.color.neutral[600],
                            pressed: tokens.color.neutral[700]
                        }
                    },
                    action: {
                        primary: {
                            hovered: tokens.color.neutral[600],
                            pressed: tokens.color.neutral[700]
                        },
                        secondary: {
                            hovered: tokens.color.neutral[600],
                            pressed: tokens.color.neutral[700]
                        }
                    }
                },
                background: {
                    action: {
                        primary: {
                            hovered: tokens.color.neutral[600],
                            pressed: tokens.color.neutral[700]
                        }
                    }
                }
            },
            themeTokens: {
                dark: {
                    text: {
                        onAction: {
                            secondary: {
                                hovered: tokens.color.neutral[0],
                                pressed: tokens.color.neutral[100]
                            }
                        },
                        action: {
                            primary: {
                                hovered: tokens.color.neutral[0],
                                pressed: tokens.color.neutral[100]
                            },
                            secondary: {
                                hovered: tokens.color.neutral[0],
                                pressed: tokens.color.neutral[100]
                            }
                        }
                    },
                    background: {
                        action: {
                            primary: {
                                hovered: tokens.color.neutral[0],
                                pressed: tokens.color.neutral[100]
                            }
                        }
                    }
                }
            }
        }
    }
};

//# sourceMappingURL=Chroma.js.map